import {
  IonRow,
  IonCol,
  IonCard,
  IonCardHeader,
  IonItem,
  IonCardContent,
  IonTitle,
  IonIcon,
} from "@ionic/react";
import { lazy, Suspense, useState } from "react";
import React, { useContext, useEffect } from "react";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import { ComponentLayout } from "../../types";
//import BreachThreshold from "../BreachThreshold/BreachThreshold";
import { useBreachThreshold } from "../BreachThreshold/useBreachThreshold";
import GroupedReadingMethodChart, {
  GroupedReadingMethodChartProps,
} from "../Charts/GroupedReadingMethodChart";
import TotalReadingsPieChart from "../Charts/TotalReadingsPieChart";
import UsersCountChart from "../Charts/UsersCountChart";
//import GroupReadingsComponent from "../GroupReadingsComponent";
//import UsersComponent from "../UsersComponent";
import * as Helpers from "../../services/Helpers";
//import CycleDaysActivity from "../CycleDaysActivity/CycleDaysActivity";
//import RewardsProgram from "../RewardsProgram/RewardsProgram";
import moment from "moment";
import { Box } from "@mui/system";
import styled from "styled-components";
import { Card } from "@material-ui/core";

const LazyLoadBreachComponent = lazy(
  () => import("../BreachThreshold/BreachThreshold")
);
const LazyLoadCycleDaysActivityComponent = lazy(
  () => import("../CycleDaysActivity/CycleDaysActivity")
);

const LazyLoadUsersComponent = lazy(() => import("../UsersComponent"));

const LazyLoadGroupReadingsComponent = lazy(
  () => import("../GroupReadingsComponent")
);

const LazyLoadRewardsProgramComponent = lazy(
  () => import("../RewardsProgram/RewardsProgram")
);

const LazyLoadScheduleMessagesComponent = lazy(
  () => import("../ScheduleMessages/ScheduleMessages")
);

const LazyLoadSurveyResultsComponent = lazy(
  () => import("../SurveyResults/SurveyResults")
);
const LazyLoadPatientsPendingApprovalComponent = lazy(
  () => import("../PatientsPendingApproval")
);
interface Props {
  componentLayout: any;
  render: any;
}

const LayoutItem: React.FC<Props> = ({ componentLayout, render }) => {
  const { userState } = useContext(ApplicationContext);
  const { providerState } = useContext(ProviderContext);
  const { row, columns, deleteRow } = useBreachThreshold();
  const dateFormatString = "YYYY-MM-DD";
  const groupedReadingMethodChart = {
    startDate: moment(new Date(), dateFormatString).add(-1, "months"),
    endDate: moment(new Date(), dateFormatString),
  };

  useEffect((): any => {
    let isSubscribed = false;
    if (!isSubscribed) {
    }
    return () => (isSubscribed = true);
  });

  return (
    <>
      {componentLayout.component ? (
        componentLayout.component.name == "Breaches" ? (
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadBreachComponent />
          </Suspense>
        ) : componentLayout.component.name == "BillingCycle" ? (
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadCycleDaysActivityComponent />
          </Suspense>
        ) : componentLayout.component.name == "LatestTenReadings" ? (
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadGroupReadingsComponent type="Group" />
          </Suspense>
        ) : componentLayout.component.name == "RewardProgram" ? (
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadRewardsProgramComponent />
          </Suspense>
        ) : componentLayout.component.name == "ScheduleMessages" ? (
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadScheduleMessagesComponent />
          </Suspense>
        ) : componentLayout.component.name == "SurveyResults" ? (
          <Suspense fallback={<p>loading...</p>}>
            <LazyLoadSurveyResultsComponent />
          </Suspense>
        ) :
          componentLayout.component.name == "Charts" ? (
            <Card>
              <IonCol className="col-6">
                <IonCard>
                  <IonCardHeader>
                    <IonItem>
                      {Helpers.getDisplayLabel(providerState)} per provider
                    </IonItem>
                  </IonCardHeader>
                  <div
                    style={{
                      height: '30%',
                      width: '30%',
                      marginLeft: 300
                    }}>
                    <UsersCountChart />
                  </div>
                </IonCard>
              </IonCol>

              <div className="row" style={{ backgroundColor: 'white' }}>
                <div className="col col-6" style={{ backgroundColor: 'white' }}>
                  <IonCard style={{ backgroundColor: 'white' }}>
                    <IonCardHeader style={{ backgroundColor: 'white' }}>
                      <IonItem style={{ backgroundColor: 'white' }}>Readings count (last 30 days)</IonItem>
                    </IonCardHeader>
                    <IonCardContent>
                      <TotalReadingsPieChart
                        groupId={providerState.providerId}
                        type="Group"
                      />
                    </IonCardContent>
                  </IonCard>
                </div>

                <div className="col col-6" style={{ backgroundColor: 'white' }}>
                  <IonCard style={{ backgroundColor: 'white' }}>
                    <IonCardHeader style={{ backgroundColor: 'white' }}>
                      <IonItem style={{ backgroundColor: 'white' }}> Manual vs Automated (last 30 days)</IonItem>
                    </IonCardHeader>
                    <IonCardContent>
                      <GroupedReadingMethodChart
                        startDate={groupedReadingMethodChart.startDate}
                        endDate={groupedReadingMethodChart.endDate}
                      />
                    </IonCardContent>
                  </IonCard>
                </div>
              </div>

              {/* <IonCol className="col-6">
                <IonCard>
                  <IonCardHeader>
                    <IonItem>Readings count (last 30 days)</IonItem>
                  </IonCardHeader>
                  <div style={{
                    height: '30%',
                    width: '30%'
                  }}>
                    <TotalReadingsPieChart
                      groupId={providerState.providerId}
                      type="Group"
                    />
                  </div>
                </IonCard>
              </IonCol> */}

              {/* <IonCol className="col-6">
                <IonCard>
                  <IonCardHeader>
                    <IonItem>Manual vs Automated (last 30 days)</IonItem>
                  </IonCardHeader>
                  <div style={{
                    height: '30%',
                    width: '30%'
                  }}>
                    <GroupedReadingMethodChart
                      startDate={groupedReadingMethodChart.startDate}
                      endDate={groupedReadingMethodChart.endDate}
                    />
                  </div>
                </IonCard>
              </IonCol> */}

            </Card>
          ) : componentLayout.component.name == "PatientList" ? (
            <Suspense fallback={<p>loading...</p>}>
              <LazyLoadUsersComponent type="Patients" />
            </Suspense>
          ) : componentLayout.component.name == "PendingApproval" ? (
            <Suspense fallback={<p>loading...</p>}>
              <LazyLoadPatientsPendingApprovalComponent type="Patients" />
            </Suspense>
          ) : (
            componentLayout.component.name
          )
      ) : (
        componentLayout.i
      )}
    </>
  );
};

export default LayoutItem;
